<template>
  <div class="widget-intro-text-block" data-animate="preloader-opacity">
    <div
      class="widget-intro-text-block-title title-m-3 is-text-uppercase m-bottom-1"
      v-if="title && title !== ''"
      v-anim-reveal-text
      v-html="title"
    />
    <div
      class="widget-intro-text-block-content"
      :class="{ 'text-xl-3': !smallFontSize,
      'bigger-font': bigFontSize }"
      v-html="text"
    />
    <template v-if="links && links.length">
     <div class="widget-intro-text-block__link-wrap m-top-24px">
      <template v-for="link in links" :key="link.id" >
        
        
           <WidgetLink v-if="link.internalLink" :link="{
          label: link.linkLabel,
          link: link.internalLink
        }" class="button-round-1 is-gradient-reverse" />
        
        
        <a v-else :href="link.linkUrl" class="button-round-1 is-gradient-reverse"  target="_blank">
          <span>{{ link.linkLabel }}</span>
        </a>
        </template>
       
      </div>

    </template>
  </div>
</template>

<script>
export default {
  name: 'WidgetIntroTextBlock',
}
</script>

<script setup>
const props = defineProps({
  text: String,
  title: String,
  smallFontSize: Boolean,
  bigFontSize: Boolean,
  links: {type: Array,
    default: undefined
  }
})
</script>

<style lang="scss">
@import './style.scss';
</style>
